<div id="FailedDoorModal" class="modal is-touch is-short failed-door-z-index-fix" [ngClass]="{'is-open': (isOpenModal | async)}">
  <div class="modal__content">
    <div id="instructionHeader" class="modal__header h2">
      {{instructionHeaderText}}
    </div>
    <div class="modal__body pt0">
      <div class="row">
        <div id="instructionBody1" class="col-12 pb2 px2">
          {{instructionBodyText1}}
        </div>
        <div id="instructionBody2" class="col-12 px2">
          {{instructionBodyText2}}
        </div>
      </div>
      <div class="row p2">
        <absg-spinner id="searchSpinner" [show]="showSearchSpinner$ | async"></absg-spinner>
        <div class="items col-12 border-top border-gray-87 pt2">
          @if (!hasNoFailedDoors()) {
            <div>
              {{instructionBodyText3}}
            </div>
          }
          <div class="row">
            @for (failedAccessPoint of failedAccessPoints; track trackItem($index, failedAccessPoint)) {
              <div class="col-3 pr2 mb1">
                <div id="{{getFailedDoorId(failedAccessPoint)}}" class="py2 border border-gray-87 border-radius center" [ngClass]="{'bg-maroon border-maroon white': isDoorInTransitionState(failedAccessPoint),
                      'bg-white teal': isDoorInResolvedState(failedAccessPoint),
                      'bg-gray-93': isDoorInFailedState(failedAccessPoint)}">
                  <div class="row">
                    <strong>
                      @if (isDoorInResolvedState(failedAccessPoint)) {
                        <span>
                          <svg>
                            <use xlink:href="./assets/icons/connect-icons.svg#Check"></use>
                          </svg>
                        </span>
                      }
                      {{failedAccessPoint.name}}
                    </strong>
                  </div>
                  <div class="row">
                    <div id="{{getFailedDoorInstructionId(failedAccessPoint)}}" class="center pt1">
                      {{failedAccessPoint.statusMessage}}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="modal__footer">
      <div class="flex-auto">
        @if (!hasNoFailedDoors()) {
          <button id="closeResolveDoorBtn" class="btn btn--true-blue-inverse" (click)="closeModal()">Close</button>
        }
      </div>
      <ng-template [ncCheckPermissions]="[storageTabPermission]">
        <div class="flex-auto">
          <button id="adminSettingsOverrideBtn" class="btn btn--core-blue" (click)="onSettingsClick()">Station Settings</button>
        </div>
      </ng-template>
      <div class="flex">
        <button class="btn btn--true-blue" id="resolveRefreshBtn" [disabled]="hasNoFailedDoors()" (click)="refreshList()">Refresh</button>
      </div>
    </div>
  </div>
</div>